const actions = {
	INIT_ASSET: "INIT_ASSET",
	OVERRIDE_VIN: "OVERRIDE_VIN",
	OVERRIDE_SERIAL_NUMBER: "OVERRIDE_SERIAL_NUMBER",
	OVERRIDE_YEAR: "OVERRIDE_YEAR",
	OVERRIDE_TRUCK_BODY_YEAR: "OVERRIDE_TRUCK_BODY_YEAR",
	OVERRIDE_MAKE: "OVERRIDE_MAKE",
	OVERRIDE_TRUCK_BODY_MAKE: "OVERRIDE_TRUCK_BODY_MAKE",
	OVERRIDE_MODEL: "OVERRIDE_MODEL",
	OVERRIDE_TRUCK_BODY_MODEL: "OVERRIDE_TRUCK_BODY_MODEL",
	OVERRIDE_DESCRIPTION: "OVERRIDE_DESCRIPTION",
	OVERRIDE_TRUCK_BODY_DESCRIPTION: "OVERRIDE_TRUCK_BODY_DESCRIPTION",
	OVERRIDE_EW_DESCRIPTION: "OVERRIDE_EW_DESCRIPTION",
	OVERRIDE_CONDITION: "OVERRIDE_CONDITION",
	OVERRIDE_HOURS: "OVERRIDE_HOURS",
	OVERRIDE_MILEAGE: "OVERRIDE_MILEAGE",
	SEARCH_VIN: "SEARCH_VIN",
	PD_OVERRIDE_CATEGORY: "PD_OVERRIDE_CATEGORY",
	PD_OVERRIDE_TRUCK_BODY_CATEGORY: "PD_OVERRIDE_TRUCK_BODY_CATEGORY",
	IS_MANUAL_YEAR: "IS_MANUAL_YEAR",
	IS_MANUAL_CATEGORY: "IS_MANUAL_CATEGORY",
	IS_MANUAL_MAKE: "IS_MANUAL_MAKE",
	IS_MANUAL_MODEL: "IS_MANUAL_MODEL",
	IS_MANUAL_CONFIG: "IS_MANUAL_CONFIG",
	SET_OVERRIDE_VIN: "SET_OVERRIDE_VIN",
	SET_OVERRIDE_SERIAL_NUMBER: "SET_OVERRIDE_SERIAL_NUMBER",
	SET_YEAR_CHOICES: "YEAR_CHOICES",
	SET_CATEGORY_CHOICES: "SET_CATEGORY_CHOICES",
	SET_TRUCK_BODY_CATEGORY_CHOICES: "SET_TRUCK_BODY_CATEGORY_CHOICES",
	SET_MAKE_CHOICES: "MAKE_CHOICES",
	SET_TRUCK_BODY_MAKE_CHOICES: "SET_TRUCK_BODY_MAKE_CHOICES",
	SET_MODEL_CHOICES: "MODEL_CHOICES",
	SET_TRUCK_BODY_MODEL_CHOICES: "SET_TRUCK_BODY_MODEL_CHOICES",
	SET_CONFIG_CHOICES: "CONFIG_CHOICES",
	SET_TRUCK_BODY_CONFIG_CHOICES: "SET_TRUCK_BODY_CONFIG_CHOICES",
	SET_OVERRIDE_DESCRIPTION: "SET_OVERRIDE_DESCRIPTION",
	SET_OVERRIDE_TRUCK_BODY_DESCRIPTION: "SET_OVERRIDE_TRUCK_BODY_DESCRIPTION",
	SET_OVERRIDE_EW_DESCRIPTION: "SET_OVERRIDE_EW_DESCRIPTION",
	SET_ASSET_CONFIG: "SET_ASSET_CONFIG",
	SET_MANUFACTURER_MODEL: "SET_MANUFACTURER_MODEL",
	SAVE_CATEGORY: "SAVE_CATEGORY",
	SAVE_TRUCK_CATEGORY: "SAVE_TRUCK_CATEGORY",
	SAVE_MAKE: "SAVE_MAKE",
	SAVE_MODEL: "SAVE_MODEL",
	SAVE_EW_YEAR: "SAVE_EW_YEAR",
	RESET: "RESET",
	RESET_TRUCK_BODY: "RESET_TRUCK_BODY",
	FIND_BY_VIN: "FIND_BY_VIN",
	FIND_EW_BY_SN: "FIND_EW_BY_SN",
	LOAD_YEAR_CHOICES: "LOAD_YEAR_CHOICES",
	LOAD_EW_YEAR_CHOICES: "LOAD_EW_YEAR_CHOICES",
	LOAD_CATEGORY_CHOICES: "LOAD_CATEGORY_CHOICES",
	LOAD_TRUCK_BODY_CATEGORY_CHOICES: "LOAD_TRUCK_BODY_CATEGORY_CHOICES",
	LOAD_MAKE_CHOICES: "LOAD_MAKE_CHOICES",
	LOAD_TRUCK_BODY_MAKE_CHOICES: "LOAD_TRUCK_BODY_MAKE_CHOICES",
	LOAD_EW_MAKE_CHOICES: "LOAD_EW_MAKE_CHOICES",
	LOAD_MODEL_CHOICES: "LOAD_MODEL_CHOICES",
	LOAD_TRUCK_BODY_MODEL_CHOICES: "LOAD_TRUCK_BODY_MODEL_CHOICES",
	LOAD_EW_MODEL_CHOICES: "LOAD_EW_MODEL_CHOICES",
	LOAD_CONFIG_CHOICES: "LOAD_CONFIG_CHOICES",
	LOAD_TRUCK_BODY_CONFIG_CHOICES: "LOAD_TRUCK_BODY_CONFIG_CHOICES",
	LOAD_EW_CONFIG_CHOICES: "LOAD_EW_CONFIG_CHOICES",
	SET_SEARCH_VIN: "SET_SEARCH_VIN",
	SET_TRAILER_ASSET_CONFIG: "SET_TRAILER_ASSET_CONFIG",
	SET_TRUCK_CHASSIS_ASSET_CONFIG: "SET_TRUCK_CHASSIS_ASSET_CONFIG",
	SET_TRUCK_BODY_ASSET_CONFIG: "SET_TRUCK_BODY_ASSET_CONFIG",
	SET_OVERRIDE_CONDITION: "SET_OVERRIDE_CONDITION",
	SET_OVERRIDE_HOURS: "SET_OVERRIDE_HOURS",
	SET_OVERRIDE_MILEAGE: "SET_OVERRIDE_MILEAGE",
	SELECT_EW_YEAR: "SELECT_EW_YEAR",
	VERIFY_EW_MAKE: "VERIFY_EW_MAKE",
	SET_MODEL_MANUAL: "SET_MODEL_MANUAL",
	VERIFY_EW_MODEL: "VERIFY_EW_MODEL",
	EDIT_ASSET_DETAILS: "EDIT_ASSET_DETAILS",
	EDIT_TRUCK_BODY_ASSET_DETAILS: "EDIT_TRUCK_BODY_ASSET_DETAILS",
	DELETE_ASSET_OVERRIDE: "DELETE_ASSET_OVERRIDE",
	SET_MANUAL_OVERRIDE: "SET_MANUAL_OVERRIDE",
	DISABLE_MANUAL_OVERRIDE: "DISABLE_MANUAL_OVERRIDE",
	UPDATE_NO_VIN_FOUND: "UPDATE_NO_VIN_FOUND",

};

let initialConditions = {
	searchVIN: true,
	isYear: true,
	isCategory: true,
	isMake: false,
	isModel: false,
	isManualYear: false,
	isManualCategory: false,
	isManualMake: false,
	isManualModel: false,
	isManualConfig: false,
	edit_asset: false,
	edit_truck_body: false,
	yearChoices: [],
	categoryChoices: [],
	makeChoices: [],
	modelChoices: [],
	configChoices: [],
	truckBodyCategoryChoices: [],
	truckBodyMakeChoices: [],
	truckBodyModelChoices: [],
	truckBodyConfigChoices: [],
	reset: false,
};

const assetReducer = (state, action) => {
	let [asset, conditions] = state;
	switch (action.type) {
		case actions.INIT_ASSET: {
			const pdValues = calculatePDValues(action.payload);
			asset = {
				...asset,
				...action.payload,
				override_vin_found: false,
				pd_values: pdValues,
			};
			return [asset, conditions];
		}

		case actions.SEARCH_VIN: {
			conditions = {
				...conditions,
				searchVIN: action.payload,
				isYear: false,
				isCategory: false,
				isMake: false,
				isModel: false,


			};
			return [asset, conditions];
		}

		case actions.SET_MANUAL_OVERRIDE: {
			conditions = {
				...conditions,
				isManualConfig: true,
				isManualMake: true,
				isManualModel: true,
				searchVIN: false,

			};
			return [asset, conditions];
		}

		case actions.DISABLE_MANUAL_OVERRIDE: {
			conditions = {
				...conditions,

				isManualConfig: false,
				isManualMake: false,
				isManualModel: false,
				searchVIN: true,
				edit_asset: true
			};
			// asset.override_vin = null
			return [asset, conditions];
		}

		case actions.UPDATE_NO_VIN_FOUND: {
			asset = {
				...asset,
				no_vin_found: action.payload,
				override_vin_found: false
			};
			return [asset, conditions];
		}



		case actions.OVERRIDE_VIN: {
			asset = {
				...asset,
				override_vin: action.payload,
			};
			return [asset, conditions];
		}

		case actions.OVERRIDE_SERIAL_NUMBER: {
			asset = {
				...asset,
				override_serial: action.payload,
			};
			return [asset, conditions];
		}

		case actions.OVERRIDE_YEAR: {
			asset = {
				...asset,
				override_year: action.payload,
			};
			return [asset, conditions];
		}

		case actions.OVERRIDE_TRUCK_BODY_YEAR: {
			asset = {
				...asset,
				override_truck_body_year: action.payload,
			};
			return [asset, conditions];
		}

		case actions.OVERRIDE_MAKE: {
			asset = {
				...asset,
				override_make: action.payload,
			};
			return [asset, conditions];
		}

		case actions.OVERRIDE_TRUCK_BODY_MAKE: {
			asset = {
				...asset,
				override_truck_body_make: action.payload,
			};
			return [asset, conditions];
		}

		case actions.OVERRIDE_MODEL: {
			asset = {
				...asset,
				override_model: action.payload,
			};
			return [asset, conditions];
		}

		case actions.OVERRIDE_TRUCK_BODY_MODEL: {
			asset = {
				...asset,
				override_truck_body_model: action.payload,
			};
			return [asset, conditions];
		}

		case actions.OVERRIDE_DESCRIPTION: {
			asset = {
				...asset,
				pd_override_configurationid: action.payload.configurationId,
				override_description: action.payload.override_des,
			};
			conditions = {
				...initialConditions,
				reset: conditions.reset,
				yearChoices: conditions.yearChoices,
				edit_asset: true,
			};
			return [asset, conditions];
		}

		case actions.OVERRIDE_TRUCK_BODY_DESCRIPTION: {
			asset = {
				...asset,
				pd_truck_body_override_configurationid: action.payload.configurationId,
				pd_truck_body_override_configuration: action.payload.configuration,
				override_truck_body_description: action.payload.specs.description,
			};
			conditions = {
				...initialConditions,
				edit_truck_body: true,
			};
			return [asset, conditions];
		}

		case actions.OVERRIDE_EW_DESCRIPTION: {
			asset = {
				...asset,
				override_model: action.payload.modelName,
				override_description:
					action.payload.categoryName + " - " + action.payload.subtypeName,
				pd_override_configurationid: action.payload.modelId,
				pd_override_classification: action.payload.classificationName,
				pd_override_classificationid: action.payload.classificationId,
				pd_override_category: action.payload.categoryName,
				pd_override_categoryid: action.payload.categoryId,
				pd_override_subtype: action.payload.subtypeName,
				pd_override_subtypeid: action.payload.subtypeId,
				override_year: action.payload.modelYear
					? action.payload.modelYear
					: asset.override_year,
			};

			const yearChoices = [];

			if (!action.payload.modelYear) {
				let currentYear = new Date().getFullYear();
				let firstYear = currentYear - 25;
				let lastYear = currentYear + 1;

				if (conditions.configChoices.length) {
					firstYear = conditions.configChoices[0].dateIntroduced
						? Number(conditions.configChoices[0].dateIntroduced.substr(0, 4))
						: firstYear;
					lastYear = conditions.configChoices[0].dateDiscontinued
						? Number(conditions.configChoices[0].dateDiscontinued.substr(0, 4))
						: lastYear;
				}
				for (let x = firstYear; x <= lastYear; x++) yearChoices.push(x.toString());
			}

			conditions = {
				...conditions,
				yearChoices: yearChoices,
				isYear: true,
				isManualYear: false,
				isManualConfig: false,
				configChoices: [],
			};
			return [asset, conditions];
		}

		case actions.OVERRIDE_CONDITION: {
			asset = {
				...asset,
				override_condition: action.payload,
			};

			return [asset, conditions];
		}

		case actions.OVERRIDE_HOURS: {
			asset = {
				...asset,
				override_hours: action.payload,
			};

			return [asset, conditions];
		}

		case actions.OVERRIDE_MILEAGE: {
			asset = {
				...asset,
				override_mileage: action.payload,
			};

			return [asset, conditions];
		}

		case actions.PD_OVERRIDE_CATEGORY: {
			asset = {
				...asset,
				pd_override_categoryid: action.payload.categoryId,
				pd_override_category: action.payload.categoryName,
			};
			return [asset, conditions];
		}

		case actions.PD_OVERRIDE_TRUCK_BODY_CATEGORY: {
			asset = {
				...asset,
				pd_truck_body_override_categoryid: action.payload.categoryId,
				pd_truck_body_override_category: action.payload.categoryName,
				override_truck_body_make: "",
				override_truck_body_model: "",
				pd_truck_body_override_configurationid: "",
				override_truck_body_description: "",
			};
			return [asset, conditions];
		}

		case actions.SET_OVERRIDE_VIN: {
			asset = {
				...asset,
				override_vin_found: true,
				override_year: action.payload.data.modelYear,
				pd_override_classificationid: action.payload.data.classificationId,
				pd_override_category: action.payload.data.categoryName,
				pd_override_categoryid: action.payload.data.categoryId,
				override_make: action.payload.data.manufacturerName,
				override_model: action.payload.data.modelName,
				override_description: action.payload.vin_des,
				pd_override_configurationid: action.payload.data.configurationId,
			};
			conditions = {
				...conditions,
				searchVIN: false,
				isCategory: true,
				isYear: true,
			};
			return [asset, conditions];
		}

		case actions.SET_OVERRIDE_SERIAL_NUMBER: {
			asset = {
				...asset,
				override_vin_found: false,
			};
			conditions = {
				...conditions,
				searchVIN: false,
				isCategory: false,
				isManualYear: false,
				isManualCategory: false,
				isManualMake: false,
				isManualModel: false,
				isManualConfig: false,
				isModel: false,
				yearChoices: [],
				categoryChoices: [],
				makeChoices: [],
				modelChoices: [],
				configChoices: action.payload,
			};
			return [asset, conditions];
		}

		case actions.SET_YEAR_CHOICES: {
			let currentYear = new Date().getFullYear();
			let years = [];
			for (let x = currentYear - 40; x <= currentYear + 3; x++) years.push(x.toString());

			asset = {
				...asset,
				override_year: "",
			};
			conditions = {
				...conditions,
				yearChoices: years,
				isManualYear: false,
			};
			return [asset, conditions];
		}

		case actions.LOAD_EW_YEAR_CHOICES: {
			const yearChoices = [];
			const currentYear = new Date().getFullYear();
			for (let x = currentYear - 25; x <= currentYear + 1; x++)
				yearChoices.push(x.toString());

			conditions = {
				...conditions,
				isYear: true,
				yearChoices: yearChoices,
				isManualYear: false,
				isManualConfig: false,
				configChoices: [],
			};
			return [asset, conditions];
		}

		case actions.SET_CATEGORY_CHOICES: {
			conditions = {
				...conditions,
				isManualCategory: false,
				isManualMake: false,
				isManualModel: false,
				isManualConfig: false,
				isYear: true,
				isMake: false,
				isModel: false,
				categoryChoices: action.payload?.sort((a, b) =>
					a.categoryName < b.categoryName ? -1 : 1
				),
			};
			return [asset, conditions];
		}

		case actions.SET_TRUCK_BODY_CATEGORY_CHOICES: {
			asset = {
				...asset,
				pd_truck_body_override_category: "",
				pd_truck_body_override_categoryid: "",
				pd_truck_body_override_configurationid: "",
				override_truck_body_make: "",
				override_truck_body_model: "",
				override_truck_body_description: "",
			};
			conditions = {
				...conditions,
				isManualCategory: false,
				isManualMake: false,
				isManualModel: false,
				isManualConfig: false,
				isYear: true,
				isMake: false,
				isModel: false,
				yearChoices: [],
				truckBodyCategoryChoices: action.payload?.sort((a, b) =>
					a.categoryName < b.categoryName ? -1 : 1
				),
				truckBodyMakeChoices: [],
				truckBodyModelChoices: [],
				truckBodyConfigChoices: [],
			};
			return [asset, conditions];
		}

		case actions.SET_MAKE_CHOICES: {
			conditions = {
				...conditions,
				makeChoices: action.payload,
			};
			return [asset, conditions];
		}
		case actions.SET_TRUCK_BODY_MAKE_CHOICES: {
			conditions = {
				...conditions,
				isManualYear: false,
				isManualCategory: false,
				isMake: true,
				isManualMake: false,
				isModel: false,
				isManualModel: false,
				isManualConfig: false,
				yearChoices: [],
				truckBodyCategoryChoices: [],
				truckBodyMakeChoices: action.payload?.sort((a, b) =>
					a.manufacturerName < b.manufacturerName ? -1 : 1
				),
				truckBodyModelChoices: [],
				truckBodyConfigChoices: [],
			};
			return [asset, conditions];
		}

		case actions.SET_MODEL_CHOICES: {
			asset = {
				...asset,
				override_model: "",
				pd_override_configurationid: "",
				override_description: "",
			};
			conditions = {
				...conditions,
				isManualYear: false,
				isManualCategory: false,
				isManualMake: false,
				isManualModel: false,
				isManualConfig: false,
				isMake: false,
				isModel: true,
				categoryChoices: [],
				makeChoices: [],
				modelChoices: action.payload?.sort((a, b) =>
					a.modelName < b.modelName ? -1 : 1
				),
				configChoices: [],
			};
			if (!action.payload) {
				conditions = {
					...conditions,
					modelChoices: [],
				};
			}
			return [asset, conditions];
		}
		case actions.SET_TRUCK_BODY_MODEL_CHOICES: {
			asset = {
				...asset,
				override_truck_body_model: "",
				pd_truck_body_override_configurationid: "",
				override_truck_body_description: "",
			};
			conditions = {
				...conditions,
				isManualYear: false,
				isManualCategory: false,
				isManualMake: false,
				isManualModel: false,
				isManualConfig: false,
				isMake: false,
				isModel: true,
				yearChoices: [],
				truckBodyCategoryChoices: [],
				truckBodyMakeChoices: [],
				truckBodyModelChoices: action.payload?.sort((a, b) =>
					a.modelName < b.modelName ? -1 : 1
				),
				truckBodyConfigChoices: [],
			};
			if (!action.payload) {
				conditions = {
					...conditions,
					truckBodyModelChoices: [],
				};
			}
			return [asset, conditions];
		}

		case actions.SET_CONFIG_CHOICES: {
			asset = {
				...asset,
			};
			conditions = {
				...conditions,
				configChoices: action.payload,
			};
			return [asset, conditions];
		}

		case actions.SET_TRUCK_BODY_CONFIG_CHOICES: {
			asset = {
				...asset,
				pd_truck_body_override_configurationid: "",
				override_truck_body_description: "",
			};
			conditions = {
				...conditions,
				isManualYear: false,
				isManualCategory: false,
				isManualMake: false,
				isManualModel: false,
				isManualConfig: false,
				isModel: false,
				yearChoices: [],
				truckBodyCategoryChoices: [],
				truckBodyMakeChoices: [],
				truckBodyModelChoices: [],
				truckBodyConfigChoices: action.payload,
			};
			if (!action.payload) {
				conditions = {
					...conditions,
					truckBodyConfigChoices: [],
				};
			}

			return [asset, conditions];
		}

		case actions.SET_OVERRIDE_DESCRIPTION: {
			asset = {
				...asset,
				override_description: action.payload,
			};
			return [asset, conditions];
		}

		case actions.SET_OVERRIDE_TRUCK_BODY_DESCRIPTION: {
			asset = {
				...asset,
				override_truck_body_description: action.payload,
			};
			return [asset, conditions];
		}

		case actions.SET_OVERRIDE_EW_DESCRIPTION: {
			asset = {
				...asset,
				override_description: action.payload,
			};
			return [asset, conditions];
		}

		case actions.SET_MANUFACTURER_MODEL: {
			asset = {
				...asset,
				pd_override_configurationid: action.payload.configurationId,
				override_description: action.payload.specs.description,
				engine_selected_manufacturer: action.payload.specs.engineMake,
				engine_selected_model: action.payload.specs.engineModel,
				trans_selected_manufacturer: action.payload.specs.transmissionMake,
				trans_selected_model: action.payload.specs.transmission,
			};
			conditions = {
				...initialConditions,
				reset: conditions.reset,
				yearChoices: conditions.yearChoices,
				edit_asset: true,
			};
			return [asset, conditions];
		}

		case actions.SAVE_MAKE: {
			conditions = {
				...conditions,
				isManualYear: false,
				isManualCategory: false,
				isManualMake: false,
				isManualModel: true,
				isManualConfig: false,
				isMake: false,
				isModel: true,
				categoryChoices: [],
				makeChoices: [],
				modelChoices: [],
				configChoices: [],
			};

			return [asset, conditions];
		}

		case actions.SAVE_TRUCK_CATEGORY: {
			conditions = {
				...conditions,
				isManualYear: false,
				isManualCategory: false,
				isManualMake: true,
				isManualModel: false,
				isManualConfig: false,
				isMake: false,
				isModel: false,
				yearChoices: [],
				categoryChoices: [],
				makeChoices: [],
				modelChoices: [],
				configChoices: [],
			};

			return [asset, conditions];
		}

		case actions.SAVE_MODEL: {
			conditions = {
				...conditions,
				isManualYear: false,
				isManualCategory: false,
				isManualMake: false,
				isManualModel: false,
				isManualConfig: true,
				isModel: false,
				categoryChoices: [],
				makeChoices: [],
				modelChoices: [],
				configChoices: [],
			};
			return [asset, conditions];
		}

		case actions.IS_MANUAL_YEAR: {
			conditions = {
				...conditions,
				isManualYear: action.payload,
				yearChoices: [],
			};
			return [asset, conditions];
		}

		case actions.IS_MANUAL_CATEGORY: {
			conditions = {
				...conditions,
				isManualCategory: action.payload,
			};
			return [asset, conditions];
		}

		case actions.IS_MANUAL_MAKE: {
			conditions = {
				...conditions,
				isManualMake: action.payload,
				isMake: false,
			};
			return [asset, conditions];
		}

		case actions.IS_MANUAL_MODEL: {
			conditions = {
				...conditions,
				isManualModel: action.payload,
				isModel: false,
			};
			return [asset, conditions];
		}

		case actions.IS_MANUAL_CONFIG: {
			conditions = {
				...conditions,
				isManualConfig: action.payload,

			};
			return [asset, conditions];
		}

		case actions.RESET: {
			conditions = {
				...initialConditions,
				yearChoices: conditions.yearChoices,
				edit_asset: true,
			};
			return [asset, conditions];
		}

		case actions.RESET_TRUCK_BODY: {
			conditions = {
				...initialConditions,
				edit_truck_body: true,
			};
			return [asset, conditions];
		}

		case actions.EDIT_ASSET_DETAILS: {
			conditions = {
				...conditions,
				edit_asset: action.payload,
				reset: !conditions.reset,
			};
			return [asset, conditions];
		}

		case actions.EDIT_TRUCK_BODY_ASSET_DETAILS: {
			conditions = {
				...conditions,
				edit_truck_body: action.payload,
				truckBodyCategoryChoices: action.initialAsset.override_truck_body_year
					? conditions.truckBodyCategoryChoices
					: [],
				truckBodyMakeChoices: action.initialAsset.pd_truck_body_override_category
					? conditions.truckBodyMakeChoices
					: [],
				truckBodyModelChoices: action.initialAsset.override_truck_body_make
					? conditions.truckBodyModelChoices
					: [],
				truckBodyConfigChoices: action.initialAsset.override_truck_body_model
					? conditions.truckBodyConfigChoices
					: [],
			};
			asset = {
				...asset,
				override_truck_body_year: action.initialAsset.override_truck_body_year,
				pd_truck_body_override_category:
					action.initialAsset.pd_truck_body_override_category,
				pd_truck_body_override_categoryid:
					action.initialAsset.pd_truck_body_override_categoryid,
				override_truck_body_make: action.initialAsset.override_truck_body_make,
				override_truck_body_model: action.initialAsset.override_truck_body_model,
				pd_truck_body_override_configurationid:
					action.initialAsset.pd_truck_body_override_configurationid,
				override_truck_body_description:
					action.initialAsset.override_truck_body_description,
			};
			return [asset, conditions];
		}

		case actions.DELETE_ASSET_OVERRIDE: {
			conditions = {
				...conditions,
				edit_asset: action.payload,
				isManualYear: false,
				isManualCategory: false,
				isManualMake: false,
				isManualModel: false,
				isManualConfig: false,
				isModel: false,
				categoryChoices: [],
				makeChoices: [],
				modelChoices: [],
				configChoices: [],
				yearChoices: conditions?.yearChoices,
				searchVIN: !action.initialAsset?.no_vin_found
			};
			asset = {
				...asset,
				override_vin: action.initialAsset.override_vin,
				override_year: action.initialAsset.override_year,
				pd_override_category: action.initialAsset.pd_override_category,
				override_make: action.initialAsset.override_make,
				override_model: action.initialAsset.override_model,
				override_description: action.initialAsset.override_description,
				override_condition: action.initialAsset.override_condition,
				override_mileage: action.initialAsset.override_mileage,
				no_vin_found: action.initialAsset?.no_vin_found
			};
			return [asset, conditions];
		}

		default:
			return state;
	}
};

const calculatePDValues = (asset) => {
	const pdValues = {};
	const totalItem = {
		retailValue: 0,
		wholesaleValue: 0,
		financeValue: 0,
		nmefValue: 0,
	};
	if (asset) {
		totalItem.type = asset.type;
		const vehicleItem = {};
		vehicleItem.type = asset.type;
		vehicleItem.description =
			asset.year ||
			asset.override_year + " " + asset.make ||
			asset.override_make + " " + asset.model ||
			asset.override_model + " - " + asset.description;
		vehicleItem.overrideDescription = asset.override_description || "";
		vehicleItem.retailValue =
			asset.override_retail_price > 0
				? asset.override_retail_price
				: asset.primary_retail_price || 0;
		vehicleItem.wholesaleValue =
			asset.override_retail_price > 0
				? asset.override_trade_in_high
				: asset.wholesale || 0;
		vehicleItem.financeValue =
			asset.pd_override_finance_value > 0
				? asset.pd_override_finance_value
				: asset.pd_finance_value || 0;
		vehicleItem.nmefValue =
			asset.override_nmef_value > 0
				? asset.override_nmef_value
				: asset.nmef_value || 0;

		totalItem.retailValue += vehicleItem.retailValue || 0;
		totalItem.wholesaleValue += vehicleItem.wholesaleValue || 0;
		totalItem.financeValue += vehicleItem.financeValue || 0;
		totalItem.nmefValue += vehicleItem.nmefValue || 0;

		pdValues.vehicleItem = vehicleItem;

		if (asset.type === "Truck with Body") {
			const bodyItem = {};
			bodyItem.type = "Body - " + asset.truck_body_category;
			bodyItem.description =
				asset.truck_body_year +
				" " +
				asset.truck_body_model +
				" " +
				asset.truck_body_type +
				" - " +
				asset.truck_body_description;
			bodyItem.overrideDescription = asset.override_truck_body_description || "";
			bodyItem.retailValue =
				asset.override_truck_body_retail_price > 0
					? asset.override_truck_body_retail_price
					: asset.primary_truck_body_retail_price || 0;
			bodyItem.wholesaleValue =
				asset.override_truck_body_wholesale_price > 0
					? asset.override_truck_body_wholesale_price
					: asset.primary_truck_body_wholesale_price || 0;

			bodyItem.financeValue =
				asset.pd_truck_body_override_finance_value > 0
					? asset.pd_truck_body_override_finance_value
					: asset.pd_truck_body_finance_value || 0;

			totalItem.retailValue += bodyItem.retailValue || 0;
			totalItem.wholesaleValue += bodyItem.wholesaleValue || 0;
			totalItem.financeValue += bodyItem.financeValue || 0;
			totalItem.nmefValue += bodyItem.nmefValue || 0;

			pdValues.bodyItem = bodyItem;
		}
		pdValues.totalItem = totalItem;
	}
	return pdValues;
};

export { assetReducer, actions, initialConditions };
